/* eslint-disable camelcase, css-modules/no-unused-class, no-nested-ternary  */
import { FC, useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { selectIsLeanUser, selectToken } from '@redux/slices/userSlice';
import { SmallLoader } from 'learning-panel-components';
import { useGetTeamsLeaderboards } from '@queries/core/homepage';
import { coreService } from 'network-utils';
import { translate } from 'translations';
import TeamLeaderboard from './teamLeaderbaord';
import styles from './userLeaderboard.module.scss';

const TeamLeaderboardContainer: FC<{ searchString: string }> = ({ searchString }: { searchString: string }) => {
    const token = useSelector(selectToken);
    const limit = 20;
    const [allTeams, setAllTeams] = useState<coreService.HomeTeamLeaderboard[]>([]);
    const [myTeams, setMyTeams] = useState<coreService.HomeTeamLeaderboard[]>([]);
    const [isEmptyState, setIsEmptyState] = useState<boolean>(false);
    const [isEmptyStateMyTeams, setIsEmptyStateMyTeams] = useState<boolean>(false);
    const [totalTeams, setTotalTeams] = useState<number>(0);
    const [offset, setOffset] = useState<number>(0);
    const [teamsOpenData, setTeamsOpenData] = useState<{ [teamId: string]: boolean }>({});
    const isLeanUser = useSelector(selectIsLeanUser);

    const { isLoading: teamsLeaderboardIsLoading, data: teamsLeaderboardsData } = useGetTeamsLeaderboards(token, {
        search: searchString,
        offset,
        limit,
        enableQuery: !isLeanUser
    });

    useEffect(() => {
        if (!teamsLeaderboardsData) return;
        if ((teamsLeaderboardsData as any).success === false) return;
        setAllTeams(teamsLeaderboardsData.teams);
        setMyTeams(teamsLeaderboardsData.myTeams);
        setTotalTeams(totalTeams);
    }, [teamsLeaderboardsData]);

    useEffect(() => {
        setOffset(0);
    }, [searchString]);

    const onLoadMore = () => {
        setOffset(offset + limit);
    };

    const onChangeOpenMode = (teamId: string, teamType: string) => {
        const myTeamsOpenDataTemp = { ...teamsOpenData };
        myTeamsOpenDataTemp[`${teamId}-${teamType}`] = !(
            Object.prototype.hasOwnProperty.call(myTeamsOpenDataTemp, `${teamId}-${teamType}`) &&
            myTeamsOpenDataTemp[`${teamId}-${teamType}`]
        );
        setTeamsOpenData({ ...myTeamsOpenDataTemp });
    };

    return isEmptyState && isEmptyStateMyTeams && searchString === '' ? (
        <div></div>
    ) : isEmptyState && isEmptyStateMyTeams ? (
        <div className={styles['empty-state']}>
            <div className={styles.title}>{translate('noMatchingResults')}</div>
            <div className={styles['sub-title']}>{translate('TryUsingDifferentSearchWord')}</div>
        </div>
    ) : teamsLeaderboardIsLoading || allTeams.length === 0 ? (
        <SmallLoader size="100px" />
    ) : (
        allTeams && (
            <TeamLeaderboard
                onLoadMore={onLoadMore}
                hasMore={offset + limit < totalTeams}
                teams={allTeams}
                myTeams={myTeams}
                totalTeams={totalTeams}
                onChangeOpenMode={onChangeOpenMode}
                teamsUsersOpenState={teamsOpenData}
                searchString={searchString}
            />
        )
    );
};

export default TeamLeaderboardContainer;
